// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productGridContainerStyle } from "@guestsupply/App/Components/Product/ProductGridContainer";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productGridContainerStyle.addToCartContainer = {
    css: css`
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
productGridContainerStyle.addToCartActions = {
    css: css`
        display: flex;
        width: 100%;
        flex: 1;
    `,
};

productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        ${xScreen("lte", "sm")} {
            &&& {
                display: flex;
                align-items: center;
            }
        }
    `,
};
